import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";

import { GoHireHeader, UnlockAdvancedHiringTools, JobDetailsTabsNavigation } from "../../components";

import CandidatesTab from "./tabs/CandidatesTab";
import JobOverviewTab from "./tabs/JobOverviewTab";

const JobDetailsPage = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "jobDetailsPage" });
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  return (
    <Box sx={styles.container}>
      <GoHireHeader />
      <UnlockAdvancedHiringTools />
      <JobDetailsTabsNavigation />
      {tab !== "candidates" && <JobOverviewTab />}
      {tab === "candidates" && <CandidatesTab />}
    </Box>
  );
};

export default JobDetailsPage;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
